import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = {
  key: 0,
  class: "donation-payment-cycle"
}
const _hoisted_3 = { class: "position-relative mt-60" }
const _hoisted_4 = { class: "donation-payment-method" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($props.show_recurring && $props.strings)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("a", {
            href: "#",
            class: _normalizeClass($setup.store.recurring && 'active'),
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.store.recurring = true), ["prevent"]))
          }, _toDisplayString($props.strings.recurring), 3 /* TEXT, CLASS */),
          _createElementVNode("a", {
            href: "#",
            class: _normalizeClass(!$setup.store.recurring && 'active'),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.store.recurring = false), ["prevent"]))
          }, _toDisplayString($props.strings.one_time), 3 /* TEXT, CLASS */)
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.gateways, (gateway, gateway_id) => {
          return (_openBlock(), _createElementBlock("a", {
            onClick: _withModifiers(($event: any) => ($setup.setValue('payment_method', gateway.id)), ["prevent"]),
            class: _normalizeClass([
							'mb-3',
							gateway.id === $setup.store.payment_method && 'active'
						]),
            title: "",
            href: "#"
          }, [
            _createElementVNode("span", null, [
              _createElementVNode("img", {
                src: gateway.icon,
                alt: ""
              }, null, 8 /* PROPS */, _hoisted_6)
            ]),
            _createTextVNode(" " + _toDisplayString(gateway.title ? gateway.title : gateway.name), 1 /* TEXT */)
          ], 10 /* CLASS, PROPS */, _hoisted_5))
        }), 256 /* UNKEYED_FRAGMENT */))
      ]),
      _renderSlot(_ctx.$slots, "gateway_data")
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}